
import { useCallback } from 'react';
import { WizardState, WizardActions } from './types';

export const useWizardNavigation = (
  state: WizardState,
  actions: WizardActions,
  totalSteps: number,
  onFinalSubmit: () => Promise<boolean>
) => {
  const { currentStep } = state;
  const { setCurrentStep } = actions;

  const isLastStep = currentStep === totalSteps - 1;

  const handleNext = useCallback(async () => {
    if (isLastStep) {
      return await onFinalSubmit();
    } else {
      setCurrentStep(Math.min(currentStep + 1, totalSteps - 1));
      return true;
    }
  }, [currentStep, isLastStep, onFinalSubmit, setCurrentStep, totalSteps]);

  const handleBack = useCallback(() => {
    setCurrentStep(Math.max(currentStep - 1, 0));
  }, [currentStep, setCurrentStep]);

  const isStepValid = useCallback((step: number): boolean => {
    return state.stepValidity[step] || false;
  }, [state.stepValidity]);

  return {
    isLastStep,
    handleNext,
    handleBack,
    isStepValid
  };
};
